import View from 'view/view'
import Model from 'model/model'
import io from 'service/io'
import Router from 'service/router'
import locationService from 'service/location'
import UploaderModalView from 'component/uploader/modal'
import uploaderService from 'service/uploader'

const PostPhotosView = View.extend({
    defaultOptions: {
        gallery: null, // required
    },

    uploadModalView: null,

    events: {
        click: '_onClick',
    },

    bubbleEvents: {
        'UploadModal:submit': '_onUploadModalSubmit',
        'UploadModal:hide': '_onUploadModalHide',
    },

    initialize(options) {
        if (!options.gallery || !options.gallery.entityType) {
            throw new Error('Missing the gallery option, or gallery.entityType is not set')
        }

        this.options = this.pickOptions(options, this.defaultOptions)
    },

    _openUploadModal() {
        this.uploadModalView = this.initSubview(UploaderModalView, {
            title: `Share your ${this.options.gallery.entityType} photos`,
        }).show()
    },

    _onClick() {
        this._openUploadModal()
    },

    _onUploadModalSubmit({ filesCollection }) {
        const galleryMetaModel = new Model(this.options.gallery, { parse: true })
        const postData = {
            ids: filesCollection.getIds(),
            mediaSessionKey: uploaderService.getMediaSessionKey(),
        }

        io.post(galleryMetaModel.getLink('photos'), postData, null, 'json').then(() => {
            locationService.loadUrl(Router.path('media_gallery_index', { galleryId: galleryMetaModel.id }))
        })
    },

    _onUploadModalHide() {
        this.destroySubviews(this.uploadModalView)
        this.uploadModalView = null
    },
})

export default PostPhotosView
